/**
 * O painel do documento original ao lado do exame (E201.F2, GUS-47, ADR-0144 §8). A mesa única o
 * oferece por contexto; quem pede "Ver na fonte" dentro dela (a ficha e a conferência da leitura)
 * abre o arquivo e a página citados no painel, em vez do diálogo com a imagem da página. Fora da
 * mesa não há painel, e o diálogo segue.
 */
import { createContext, useContext } from 'react';

export interface AlvoNoPainel {
  documentoId: string;
  pagina: number;
}

export interface PainelDoDocumento {
  abrir: (alvo: AlvoNoPainel) => void;
}

export const PainelDoDocumentoContexto = createContext<PainelDoDocumento | null>(null);

export function usePainelDoDocumento(): PainelDoDocumento | null {
  return useContext(PainelDoDocumentoContexto);
}
